/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    MESSAGE_DETAILS: 'Szczegóły wiadomości',
    OK: 'OK'
  },
  ERROR: {
    ERROR: 'Błąd',
    FETCH_DATA: 'Pobierz dane',
    NO_ORDER: 'Nie można było narysować żadnej działki'
  },
  HEADER: {
    DATE: 'Data',
    MESSAGE: 'Wiadomość',
    NAME: 'Nazwa klienta',
    ORDER_CODE: 'Kod zamówienia',
    ORDER_DATE: 'Data zamówienia',
    ORDER_ID: 'Zamówienie',
    ORDER_VALUE: 'Wartość',
    PAYMENT_DATE: 'Data płatności',
    PAYMENT_STATE: 'Status płatności',
    PRICE: 'Cena',
    VALUE: 'Wartość'
  },
  LABEL: {
    COPIED: 'Skopiowane!',
    EXPORT: 'Eksport',
    GIVEWAY_DATE: 'Data losowania:',
    MONTH: 'Miesiąc',
    ORDER_PRIZE_MSG: 'Nagrodzone zamówienie:',
    PAYED: 'Płatne',
    PRIZE: 'Giveaway',
    RAFFLE: 'Giveaway',
    UNPAYED: 'Nieopłacony',
    UNTIL: 'a',
    YEAR: 'Rok'
  },
  SENTENCE: {
    NO_ROWS_ORDER_MESSAGES: 'Brak wiadomości',
    NO_ROWS_ORDER_MESSAGES_DESCRIPTION:
      'Brak wiadomości od klientów (jeszcze).',
    NO_ROWS_ORDERS: 'Brak zamówień',
    NO_ROWS_ORDERS_DESCRIPTION: 'Brak zamówień (jeszcze).'
  },
  SUCCESS: {
    SUCCESS: 'Sukces'
  },
  TOOLTIP: {
    DATE: 'Data',
    ORDER_CODE: 'Kod zamówienia',
    ORDER_ID: 'Zamówienie',
    PAYMENT_DATE: 'Data płatności',
    PAYMENT_STATE: 'Status płatności',
    PRICE: 'Cena',
    VALUE: 'Wartość'
  }
};
